import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout';
import LanguageManagement from '../../../components/siteadmin/LanguageManagement';
import { restrictUrls } from '../../../helpers/adminPrivileges';

const title = 'Languages';

export default async function action({ store }) {
  const isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
  const adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
  const privileges = store.getState().listSettings && store.getState().listSettings.privileges;

  if (!isAdminAuthenticated) {
    return { redirect: '/siteadmin/login' };
  }

  if (!restrictUrls('/siteadmin/languages', adminPrivileges, privileges)) {
    return { redirect: '/siteadmin' };
  }

  return {
    title,
    component: <AdminLayout><LanguageManagement title={title} /></AdminLayout>,
  };
}
